import { MINUTE } from '~/lib/constants';

export const PRESCRIPTION_MESSAGES_COUNT_POLLING_INTERVAL_MS = 3 * MINUTE;

export const PRESCRIPTION_MESSAGES_LOAD_ERROR_MESSAGE =
  'We were unable to load prescription messages. Please refresh the page or try again later.';
